import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'account-form',
    templateUrl: './account-form.html',
    styleUrls: ['./account-form.scss'],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AccountFormComponent {}
